import { render, staticRenderFns } from "./EmptyListScreen.vue?vue&type=template&id=364fa998&"
import script from "./EmptyListScreen.vue?vue&type=script&lang=js&"
export * from "./EmptyListScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports